/**
 * Tracking Events
 * This file is used to track events on the QMS app.
 * It listens to custom events and sends the data to Shopify's analytics.
 * All data should be prepared and sent in the format that Shopify's analytics expects.
 */

const allLinks = document.querySelectorAll(`a[href="${window.urlTracking}"]`);
allLinks.forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();

    const ecommerceData = {
      page_location: window.location.href,
      button_url: link.href,
      button_value: link.innerText,
    };
    Shopify.analytics.publish('urlClicked', ecommerceData);

    // Ensures that the data is sent to Shopify's analytics before the user is redirected
    setTimeout(() => {
      window.location.href = link.href;
    }, 1);
  });
});

window.addEventListener('klaviyoForms', function klaviyoFormsListener(event) {
  const eventData = event.detail;

  if (eventData.type !== 'submit' && eventData.type !== 'stepSubmit') return;

  const customData = {
    formId: eventData.formId,
    formSource: eventData.metaData.$source,
    type: eventData.type,
    formStep: eventData.metaData.$step_name || 'Submit Form',
    pageLocation: `${document.location.origin}${document.location.pathname}`,
    metaData: JSON.parse(JSON.stringify(eventData.metaData)),
  };

  // only track specific klaviyo events
  if (eventData.type === 'submit') {
    Shopify.analytics.publish('custom:klaviyo_form_submit', customData);
  } else if (eventData.type === 'stepSubmit') {
    Shopify.analytics.publish('custom:klaviyo_form_step', customData);
  }
});
